import { Attendee } from './attendee.model';

export class Birthday {
  public $key: string;
  public attendees: Attendee[] = [];
  public note: string = null;
  public sentToKitchen: boolean = false;

  constructor(data) {
    for (let key in data) {
      if (data.hasOwnProperty(key) && this.hasOwnProperty(key)) {
        this[key] = data[key] || null;
      }
    }
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/models/birthday.model.ts